let afterFrame: ((callback: (time: number) => void) => void) | null = null;
let afterFrameAvailable = true;

// get afterFrame if it is available, or return null if it is not
async function getAfterFrame() {
  if (afterFrame == null && afterFrameAvailable) {
    return import('afterframe')
      .then(m => {
        afterFrame = m.default;
        return afterFrame;
      })
      .catch(() => {
        afterFrameAvailable = false;
        console.warn(
          'afterFrame not available, afterFrame timings will not be reported'
        );
        return null;
      });
  }

  return afterFrame;
}

export async function afterFrameIfAvailable(callback: (time: number) => void) {
  return getAfterFrame().then(afterFrame => {
    afterFrame?.(callback);
  });
}
